import React from 'react';
import {
  BoxProps,
  CircularProgress,
  CircularProgressProps
} from '@mui/material';
import { CenteredContainer } from '@ianesthesie-kit/core';
import { DynamicOptionsLoadingProps } from 'next/dynamic';

type FallbackLoaderProps = BoxProps & {
  loaderProps?: CircularProgressProps;
  fallbackProps: DynamicOptionsLoadingProps;
};

export const FallbackLoader = ({
  loaderProps,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fallbackProps, // TODO use those
  ...wrapperProps
}: FallbackLoaderProps) => (
  <CenteredContainer {...wrapperProps}>
    <CircularProgress {...loaderProps} />
  </CenteredContainer>
);
